export default __webpack_public_path__ + "static/mobileBanner-5d3918090de35d0b04e403fa44eba0eb.png";